import type Feature from 'ol/Feature'
import type Geometry from 'ol/geom/Geometry'

import { getMap } from '../../atoms/map/utils/getMap'
import { createNonBlockingRenderByTime } from '../../renderingQueue'
import { setLayerMetadata } from '../layerMetadata'
import { findLayer } from '../utils/findLayer'

import { createRoadSegmentFeature } from './utils/createRoadSegmentFeature'

const nonblockingRender = createNonBlockingRenderByTime()

/**
 * Initialize the Features for all the existent RoadSegments
 */
export async function initializeRoadSegmentFeatures(
  roadSegments: uui.domain.ui.map.markers.MapMarkers['roadSegment'],
  mapStyles: uui.domain.ui.map.markers.MapStyles['roadSegment'],
  selection: Set<string>,
) {
  const map = getMap()
  const layer = findLayer(map, 'roadSegment')

  const features: Feature<Geometry>[] = []

  await nonblockingRender.next()

  for (const marker of Object.values(roadSegments)) {
    const selected = selection.has(marker.id)
    features.push(createRoadSegmentFeature(marker, mapStyles, selected))
  }

  // add all new features to the layer
  layer.getSource()?.addFeatures(features)

  // keep track of selected items in the current layer
  setLayerMetadata(layer, 'selection', new Set(selection))
}
